import { divide, isEmpty, round, toNumber } from 'lodash-es'

export function toDemotion(value: string | number, rate = 100) {
  let num = toNumber(value)
  num = isNaN(num) ? 0 : num
  return round(divide(num, rate), 2)
}

export function getYenPrice(price: string | number) {
  let integer = ''
  let decimal = ''
  const p = toDemotion(price).toString()
  const result = p.split('.')
  if (result.length === 2) {
    integer = result[0]
    if (parseInt(result[1]) > 0) {
      decimal = result[1]
    }
  } else {
    if (price >= 0) {
      integer = p
    }
  }
  let value = `${integer}`
  if (!isEmpty(decimal)) {
    value += `.${decimal}`
  }
  return value
}

export function getDistanceKm(m: number) {
  if (m <= 100) {
    return '0.1'
  } else {
    const km = round(m / 1000, 1).toString()
    if (km.split('.').length == 1) {
      return `${km}.0`
    } else {
      return `${km}`
    }
  }
}
/*
 * 时间转换
 */
export function getYMDHMS(timestamp: any, type?: any) {
  const time = new Date(timestamp)
  const year = time.getFullYear()
  let month: any = time.getMonth() + 1
  let date: any = time.getDate()
  let hours: any = time.getHours()
  let minute: any = time.getMinutes()
  let second: any = time.getSeconds()

  if (month < 10) {
    month = '0' + month
  }
  if (date < 10) {
    date = '0' + date
  }
  if (hours < 10) {
    hours = '0' + hours
  }
  if (minute < 10) {
    minute = '0' + minute
  }
  if (second < 10) {
    second = '0' + second
  }
  if (type === 'date') {
    return year + '-' + month + '-' + date
  } else {
    return (
      year +
      '-' +
      month +
      '-' +
      date +
      ' ' +
      hours +
      ':' +
      minute +
      ':' +
      second
    )
  }
}
/*
 * 保留两位小数
 */
export function oneDecimal(value: string | number, rate = 1000) {
  const num = toNumber(value) / rate
  if (num !== 0) {
    const length = num.toString().length
    let number
    if (length > 1) {
      number = num.toFixed(1)
    } else {
      number = num
    }
    return number
  } else {
    return 0
  }
}
// 数字转换函数
export function translateNums(value = 0, rate = 1000, fixedNum = 2) {
  // 非数字
  if (isNaN(value) || value == 0) {
    return 0
  }
  const rateNum = value / rate
  return String(rateNum).includes('.') ? rateNum.toFixed(fixedNum) : rateNum
}
